import api from './api';

const login = async ({ email, password }) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
};

const me = async () => {
    const response = await api.get('/auth/me');
    return response.data;
};

const listUsers = async () => {
    const response = await api.get('/auth/users');
    return response.data;
};

const createUser = async (payload) => {
    const response = await api.post('/auth/users', payload);
    return response.data;
};

const updateUser = async (id, payload) => {
    const response = await api.patch(`/auth/users/${id}`, payload);
    return response.data;
};

const deleteUser = async (id) => {
    const response = await api.delete(`/auth/users/${id}`);
    return response.data;
};

const AuthService = { login, me, listUsers, createUser, updateUser, deleteUser };
export default AuthService;
